import { useEffect } from 'react';

/**
 * Dev-server fallback. Production nginx serves build/appdownload (no extension)
 * as a static file before the React SPA catch-all runs.
 */
export default function AppDownloadPage() {
  useEffect(() => {
    const { search, hash } = window.location;
    window.location.replace(`/appdownload.html${search}${hash}`);
  }, []);

  return (
    <div
      style={{
        background: '#000',
        color: '#f0c060',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Georgia, serif',
      }}
    >
      Loading install page…
    </div>
  );
}
